import { Pipe, PipeTransform } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { DPFormField } from 'src/app/core/models/DPFormField';

/**
 * This pipe checks if subfield is visible or not.
 * 
 * Subfield visibility will be determined by subQuestionTriggerOptionId and current form value.
 */
@Pipe({
  name: 'subfieldVisible',
  standalone: true,
})
export class SubfieldVisiblePipe implements PipeTransform {
  transform(form: UntypedFormGroup, subfield: DPFormField): Observable<boolean> {
    if (!subfield.parentField || !subfield.subQuestionTriggerOptionId) {
      return of(true);
    }

    const triggerOptionIds = (subfield.subQuestionTriggerOptionId || '').toString().split(',');

    return form.valueChanges.pipe(
      startWith(form.value),
      map((values) => {
        try {
          const parentValue = JSON.parse(values[subfield.parentField] || {});
          return triggerOptionIds.some(optionId => parentValue[optionId] !== undefined);
        } catch {
          return false;
        }
      })
    );
  }
}
